import { render, staticRenderFns } from "./BitQSport.vue?vue&type=template&id=5906f7ca&scoped=true"
import script from "./BitQSport.vue?vue&type=script&lang=js"
export * from "./BitQSport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5906f7ca",
  null
  
)

export default component.exports